import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import createBreakpoints from './createBreakpoints';
// TODO: An identity function until we figure out how to better make use of
// this utility. Some ideas are to accept a small set of values that can be
// used to construct a full theme object. For example, imagine accepting
// the brand primary and secondary colors and deriving everything from there.
// Ambitious, but would simplify theme creation for users that prefer to
// use defaults until the need to further customize the theme is necessary.
export default function createTheme(theme) {
  return _objectSpread(_objectSpread({}, theme), {}, {
    direction: theme.direction || 'ltr',
    breakpoints: createBreakpoints(theme.breakpoints)
  });
}